import { Component } from '@angular/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import {Step1Component} from '../step-1/step-1.component';
import {NgIf} from '@angular/common';
import {Step2Component} from '../step-2/step-2.component';
import {ReservaDataService} from '../../../services/reserva-data.service';
import {ReservaService} from '../../../services/reserva.service';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {NzMessageService} from 'ng-zorro-antd/message';
import {Step3Component} from '../step-3/step-3.component';

@Component({
  selector: 'app-step-reserva',
  imports: [NzButtonModule, NzStepsModule, Step1Component, NgIf, Step2Component, NzIconDirective, Step3Component],
  templateUrl: './step-reserva.component.html',
  styleUrls: ['./step-reserva.component.css']
})
export class StepReservaComponent {
  constructor(private message: NzMessageService,private reservaDataService: ReservaDataService, private reservaService: ReservaService) {
  }
  current = 0;
  reservaCodigo: string | null = null;
  data: any [] = [];
  index = 'First-content';
  step2Data: any = {};
  selectedPersona: any = {};

  pre(): void {
    this.current -= 1;
    this.changeContent();
  }

  handlePersonaSeleccionada(): void {
    this.selectedPersona = this.reservaDataService.getData('personaSeleccionada'); // Get selected person data
    this.current += 1;
    this.changeContent();
  }

  handleStep2Completion(step2Data: any): void {
    this.step2Data = { ...step2Data, ...this.selectedPersona }; // Merge step-2 data with selected person data
    this.current += 1;
    this.changeContent();
  }
  handleStep3Completion() {
    this.changeContent();
  }
  changeContent(): void {
    switch (this.current) {
      case 0: {
        this.index = 'First-content';
        break;
      }
      case 1: {
        this.index = 'Second-content';
        break;
      }
      case 2: {
        this.index = 'Third-content';
        break;
      }
      default: {
        this.index = 'error';
      }
    }
  }
}
